import React from 'react';
import { Megaphone, Globe, Users, BarChart3 } from 'lucide-react';

const stats = [
  { value: '500+', label: 'Successful Campaigns', icon: Megaphone },
  { value: '90+', label: 'Brands Globally', icon: Globe },
  { value: '1,500+', label: 'Syndication Partners', icon: Users },
  { value: '1M+', label: 'Monthly Reach', icon: BarChart3 },
];

export default function StatsBar() {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-slate-50 border-y border-slate-100"
      aria-label="Key statistics"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, i) => {
            const Icon = stat.icon;
            return (
              <div
                key={stat.label}
                data-testid={`stat-${stat.label.toLowerCase().replace(/\s/g, '-')}`}
                className="flex flex-col items-center text-center gap-3"
              >
                <div className="w-12 h-12 rounded-xl bg-[#4AC5DB]/10 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-[#4AC5DB]" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-['Outfit'] text-3xl md:text-4xl font-bold text-slate-900">
                    {stat.value}
                  </p>
                  <p className="text-sm text-slate-500 mt-1 font-medium">{stat.label}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
